import React from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import {
  COURSE_PAUSE_REQUEST_STATUSES,
  CoursePauseRequestPagination,
  currentPageSelector,
  useFilteredCoursePauseRequests,
} from 'features/courseResume';
import CoursePauseScheduledTableHeader from '../CoursePauseScheduledTableHeader';
import CoursePauseScheduledTableRow from '../CoursePauseScheduledTableRow';
import ElementSpacePlaceholder from 'components/ElementSpacePlaceholder';
import ErrorLayout from 'components/ErrorLayout';
import GlobalLoader from 'components/GlobalLoader';
import Loader from 'components/Loader';
import styles from './CoursePauseScheduledTable.module.scss';
import Table from 'components/Table';
import TableBody from 'components/TableBody';

function CoursePauseScheduledTable() {
  const { requestType } = useParams();
  const currentPage = useSelector(currentPageSelector);
  const { data, isLoading, error, refetch, isFetching } =
    useFilteredCoursePauseRequests({
      requestType,
      coursePauseStatus: [
        COURSE_PAUSE_REQUEST_STATUSES.scheduledResume,
        COURSE_PAUSE_REQUEST_STATUSES.scheduledAccept,
      ],
    });

  if (isLoading) {
    return <Loader />;
  } else if (error) {
    return (
      <ErrorLayout
        title="Failed to load course pause requests"
        message={error.data?.message || 'Something went wrong! Try again later'}
        actionFn={refetch}
      />
    );
  } else if (data?.data?.length > 0) {
    const coursePauseRequests = data.data;

    return (
      <>
        <GlobalLoader isVisible={isFetching} />
        <Table className={styles.root}>
          <CoursePauseScheduledTableHeader />
          <TableBody className={styles.rows}>
            {coursePauseRequests?.map((request) => (
              <CoursePauseScheduledTableRow
                request={request}
                key={request.id}
              />
            ))}
          </TableBody>
        </Table>
        <ElementSpacePlaceholder elementId="to-be-resume-request-pagination" />
        <div
          id="to-be-resume-request-pagination"
          className={styles.pagination}
        >
          <CoursePauseRequestPagination
            pageCount={data.meta.total}
            currentPage={currentPage}
          />
        </div>
      </>
    );
  } else {
    return (
      <ErrorLayout
        title="No requests found!"
        message="No scheduled requests exists at the moment."
      />
    );
  }
}

export default CoursePauseScheduledTable;
